module.exports = __webpack_public_path__ + "static/media/features-split-image-03.7828d375.png";